<form [formGroup]="swapLibraryForm" autocomplete="off">
  <div class="form-controls-padding" style="margin-top: 10px">
    <mat-form-field appearance="outline" hideRequiredMarker="true">
      <mat-label i18n="@@searchProfilesLabel"
        >Search existing profiles</mat-label
        >
        <input
          matInput
          type="text"
          formControlName="filter"
          placeholder="Search existing profiles"
          i18n-placeholder="@@searchProfilesPlaceholder"
          (keyup)="onFilterChanged($event)"
          />
          <mat-icon class="search-icon-wrapper" matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label i18n="@@sortLabel">Sort</mat-label>
          <mat-select
            formControlName="sort"
            (selectionChange)="onSortChanged($event)"
            [hideSingleSelectionIndicator]="true"
            >
            @for (option of sortOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.display }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <h3 class="library-list-header" i18n="@@profileNameHeader">Profile name</h3>
        <div class="list-container">
          @if (dataSource && dataSource.length > 0) {
            <mat-list>
              @for (library of dataSource; track library) {
                <mat-list-item>
                  <div class="library-list-item-container">
                    <div class="item-layout">
                      <div
                        matListItemLine
                        [matTooltip]="library.name"
                        matTooltipClass="multiline-tooltip-wrap"
                        [matTooltipDisabled]="library.name.length < 40"
                        >
                        {{ library.name }}
                      </div>
                      <div matListItemLine>
                        {{ library.editedDt.toString() | timeAgo }}
                      </div>
                    </div>
                    <div class="button-layout">
                      @if (library.id === currentLibraryId) {
                        <div
                          class="library-buttons-container"
                          >
                          <div
                            matTooltip="Current profile"
                            i18n-matTooltip="@@currentProfileTooltip"
                            [matTooltipShowDelay]="1000"
                            [matTooltipHideDelay]="1000"
                            >
                            <button
                              class="atlas-icon-button"
                              mat-flat-button
                              color="primary"
                              disabled="true"
                              >
                              <mat-icon>swap_horiz</mat-icon>
                            </button>
                          </div>
                          <div
                            matTooltip="Delete profile"
                            i18n-matTooltip="@@deleteProfileTooltip"
                            [matTooltipShowDelay]="1000"
                            [matTooltipHideDelay]="1000"
                            >
                            <button
                              class="atlas-icon-button atlas-secondary-icon-button"
                              color="primary"
                              mat-flat-button
                              disabled="true"
                              >
                              <mat-icon>delete_outline</mat-icon>
                            </button>
                          </div>
                        </div>
                      }
                      @if (library.id !== currentLibraryId) {
                        <div
                          class="library-buttons-container"
                          >
                          @if (library.id != currentLibraryId) {
                            <button
                              class="atlas-icon-button"
                              mat-flat-button
                              color="primary"
                              (click)="onSwitchToLibrary(library.id)"
                              matTooltip="Open this profile"
                              i18n-matTooltip="@@openProfileTooltip"
                              [matTooltipShowDelay]="1000"
                              [matTooltipHideDelay]="1000"
                              >
                              <mat-icon>swap_horiz</mat-icon>
                            </button>
                          }
                          <div
                            matTooltip="Delete profile"
                            i18n-matTooltip="@@deleteProfileTooltip"
                            [matTooltipShowDelay]="1000"
                            [matTooltipHideDelay]="1000"
                            >
                            <button
                              class="atlas-icon-button atlas-secondary-icon-button"
                              mat-flat-button
                              color="primary"
                              (click)="onDeleteLibrary(library.id)"
                              [disabled]="isDeleteButtonDisabled(library.importStatus)"
                              >
                              <mat-icon>delete_outline</mat-icon>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </mat-list-item>
              }
            </mat-list>
          }
          @if (dataSource && dataSource.length == 0 && !librariesLoading) {
            <div
              class="library-list-header"
              >
              <div class="body-large" i18n="@@noRecordsFound">
          No records found, edit search criteria
        </div>
            </div>
          }

          @if (librariesLoading) {
            <div class="library-list-spinner">
              <mat-spinner diameter="34" strokeWidth="2"> </mat-spinner>
            </div>
          }
        </div>
      </div>
    </form>
